import api, { apiWrapper } from '../api/axios';

export const getDriverExpenses = async ({
  status = 'all', driver = 0, drivers = "",
  month=0, year=0, branch=0,
  page = 1, pageSize = 20, paginate = true
}) => {
  let params = {
    status,
    month,
    year,
    branch,
    page,
    page_size: pageSize,
    paginate
  };
  if (drivers) {
    params.drivers = drivers;
  } else {
    params.driver = driver;
  }
  return apiWrapper(() => api.get(`/driver/expenses/`, { params }));
};

export const getExpenseApprovals = async ({
  driver = 0,
  month=0, year=0,
  page = 1, pageSize = 20
}) => {
  let params = {
    status: "pending",
    driver,
    month,
    year,
    page,
    page_size: pageSize,
    paginate: true
  };
  return apiWrapper(() => api.get(`/driver/expenses/`, { params }));
};

export const addExpense = async (data) => {
  const formData = construct_form_data(data);
  return apiWrapper(() => api.post("/driver/expenses/", formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }));
};

export const updateDriverExpensePartial = async (id, data) => {
  const formData = construct_form_data(data);
  return apiWrapper(() => api.patch(`/driver/expenses/${id}/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }));
}

export const approveDriverExpense = async (id) => {
  return apiWrapper(() => api.post(`/driver/expenses/${id}/approve/`));
}

export const rejectDriverExpense = async (id) => {
  return apiWrapper(() => api.post(`/driver/expenses/${id}/reject/`));
}

export const deleteDriverExpense = async (id) => {
  return apiWrapper(() => api.delete(`/driver/expenses/${id}/`));
}

export const exportDriverExpenses = async ({
  month = 0,
  year = 0,
  branch = 0,
  drivers = "",
  format = "xls"
}) => {
  let params = { month, year, branch, file_format: format };
  if (drivers) {
    params = { ...params, drivers };
  }
  return apiWrapper(() => api.get(`/driver/expenses/export/`, { params, responseType: 'blob' }), true, false, true);
};

const construct_form_data = (data) => {

  let form = new FormData();

  // Add text fields
  form = add_field(form, 'expense_type', data?.expense_type);
  form = add_field(form, 'amount', data?.amount);
  form = add_field(form, 'date', data?.date);
  form = add_field(form, 'remarks', data?.remarks);
  form = add_field(form, 'reason', data?.reason);
  form = add_field(form, 'driver_id', data?.driver);
  form = add_field(form, 'needs_confirmation', data?.needs_confirmation || false);
  
  // Add file fields (make sure these are actual File objects from input type="file")
  form = add_field(form, 'supporting_doc', data?.supporting_doc);

  return form;
};

const add_field = (form, key, value) => {
  if (value) {
    form.append(key, value);
  }
  return form;
};
